import Delectory from './lib/delectory';
module.exports = Delectory;



// WEBPACK FOOTER //
// banquet/lib/DelectoryApi/index.js